// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Dashboard.responsive.css
   Responsive Stylesheet for MedGen Intelligence Dashboard
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgdash-page {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .mgdash-shell {
    grid-template-columns: 1fr !important;
    gap: 18px !important;
    padding: 12px 16px 36px !important;
    margin-top: 8px !important;
  }

  .mgdash-rail {
    position: static !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 14px !important;
  }

  /* Responsive Steps row on tablets */
  .mgdash-steps-card {
    padding: 14px 16px !important;
  }

  .mgdash-steps-card .mgdash-kicker {
    margin-bottom: 8px !important;
  }

  /* Quick Actions horizontal on tablet */
  .mgdash-action-card {
    padding: 14px 16px !important;
  }

  .mgdash-action-card .mgdash-kicker {
    margin-bottom: 8px !important;
  }

  .mgdash-action-card {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    gap: 8px !important;
  }

  .mgdash-action-card .mgdash-kicker {
    flex: 1 1 100% !important;
  }

  .mgdash-action-card .mgdash-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 8px);
    min-width: 120px !important;
    margin-top: 0 !important;
  }

  /* Hero Card */
  .mgdash-hero-card {
    grid-template-columns: 1fr !important;
    gap: 22px !important;
    padding: 24px !important;
  }

  .mgdash-cockpit {
    max-width: 100% !important;
    padding: 22px !important;
  }

  .mgdash-hero-copy h1 {
    font-size: clamp(28px, 4.2vw, 38px) !important;
    line-height: 1.08 !important;
  }

  .mgdash-patient-grid,
  .mgdash-session-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 14px !important;
  }

  .mgdash-section-head {
    grid-template-columns: 1fr !important;
    gap: 14px !important;
  }

  .mgdash-filters,
  .mgdash-filters.session {
    grid-template-columns: minmax(0, 1.4fr) 180px auto !important;
    gap: 10px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgdash-shell {
    padding: 8px 10px 28px !important;
    gap: 14px !important;
  }

  /* Steps card on mobile: compact 2x2 grid */
  .mgdash-steps-card {
    padding: 12px !important;
  }

  .mgdash-steps-card {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
  }

  .mgdash-steps-card .mgdash-kicker {
    grid-column: 1 / -1 !important;
    margin-bottom: 4px !important;
  }

  .mgdash-step {
    min-height: 48px !important;
    padding: 8px 10px !important;
    margin-bottom: 0 !important;
    grid-template-columns: 22px 1fr !important;
    column-gap: 6px !important;
  }

  .mgdash-step b {
    font-size: 11px !important;
  }

  .mgdash-step span {
    font-size: 11px !important;
    font-weight: 750 !important;
    line-height: 1.2 !important;
  }

  .mgdash-step small {
    display: none !important;
  }

  /* Action buttons stacked or 2-col on phone */
  .mgdash-action-card .mgdash-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 6px);
    min-width: 100px !important;
    min-height: 40px !important;
    font-size: 12px !important;
  }

  .mgdash-action-card .mgdash-btn:last-child {
    flex: 1 1 100% !important;
  }

  /* Selected Card */
  .mgdash-selected-card {
    padding: 14px !important;
  }

  .mgdash-selected-card h3 {
    font-size: 16px !important;
  }

  .mgdash-selected-card p {
    font-size: 12px !important;
    margin-bottom: 10px !important;
  }

  /* Hero Section */
  .mgdash-hero-card {
    padding: 16px 14px !important;
    gap: 16px !important;
    border-radius: 16px !important;
  }

  .mgdash-hero-copy h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
    letter-spacing: -0.015em !important;
  }

  .mgdash-hero-copy p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 10px 0 14px !important;
  }

  .mgdash-hero-actions {
    display: flex !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .mgdash-hero-actions .mgdash-btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 12.5px !important;
  }

  /* Activity Bar Chart */
  .mgdash-activity-card {
    margin-top: 18px !important;
    padding: 14px 12px !important;
    border-radius: 14px !important;
  }

  .mgdash-activity-head {
    margin-bottom: 12px !important;
  }

  .mgdash-activity-head strong {
    font-size: 15px !important;
  }

  .mgdash-bar-chart {
    height: 125px !important;
    gap: 8px !important;
  }

  .mgdash-bar-track {
    max-width: 44px !important;
  }

  /* Cockpit */
  .mgdash-cockpit {
    padding: 16px 14px !important;
    border-radius: 14px !important;
  }

  .mgdash-cockpit-top h3 {
    font-size: 16px !important;
  }

  .mgdash-cockpit p {
    font-size: 12px !important;
    line-height: 1.45 !important;
  }

  /* 3 Circle Stats */
  .mgdash-circle-row {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 14px 0 !important;
  }

  .mgdash-circle-stat {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }

  .mgdash-circle {
    width: 60px !important;
    height: 60px !important;
  }

  .mgdash-circle span {
    font-size: 14px !important;
    font-weight: 850 !important;
  }

  .mgdash-circle-stat p {
    font-size: 11px !important;
    margin-top: 4px !important;
  }

  .mgdash-circle-stat small {
    display: none !important;
  }

  .mgdash-cockpit-boxes {
    gap: 8px !important;
    margin-top: 14px !important;
  }

  .mgdash-cockpit-boxes div {
    padding: 10px 12px !important;
  }

  .mgdash-cockpit-boxes strong {
    font-size: 15px !important;
  }

  /* Grids to 1 column on phone */
  .mgdash-patient-grid,
  .mgdash-session-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  /* Filter toolbar */
  .mgdash-filters,
  .mgdash-filters.session {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .mgdash-filters input,
  .mgdash-filters select,
  .mgdash-filters.session input,
  .mgdash-filters.session select {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13.5px !important;
  }

  .mgdash-filters .mgdash-btn,
  .mgdash-filters.session .mgdash-btn {
    width: 100% !important;
    min-height: 40px !important;
  }

  /* Patient Card */
  .mgdash-patient-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgdash-patient-top {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .mgdash-avatar {
    width: 42px !important;
    height: 42px !important;
    font-size: 13px !important;
    flex-shrink: 0 !important;
  }

  .mgdash-patient-meta h3 {
    font-size: 15px !important;
  }

  .mgdash-count-chip {
    margin-left: auto !important;
    font-size: 10.5px !important;
  }

  .mgdash-patient-bottom {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-top: 12px !important;
    gap: 8px !important;
  }

  .mgdash-card-actions {
    display: flex !important;
    gap: 6px !important;
  }

  .mgdash-card-actions .mgdash-btn {
    min-height: 34px !important;
    padding: 6px 12px !important;
    font-size: 11.5px !important;
  }

  /* Session Card */
  .mgdash-session-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgdash-session-top {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .mgdash-session-badges {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,wBAAwB;IACxB,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA,oCAAoC;EACpC;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,uCAAuC;EACvC;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAwC;IAAxC,cAAwC;IAAxC,+BAAwC;IACxC,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA,cAAc;EACd;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,4BAA4B;EAC9B;;EAEA;;IAEE,2DAA2D;IAC3D,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;IAEE,6DAA6D;IAC7D,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA,2CAA2C;EAC3C;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,0CAA0C;IAC1C,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,6CAA6C;EAC7C;IACE,YAAoC;IAApC,cAAoC;IAApC,2BAAoC;IACpC,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA,iBAAiB;EACjB;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,uBAAuB;EACvB;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,YAAY;EACZ;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA,mBAAmB;EACnB;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,+BAA+B;EAC/B;;IAEE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA,mBAAmB;EACnB;;IAEE,qCAAqC;IACrC,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;;;;IAIE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,mBAAmB;EACrB;AACF","sourcesContent":["/* ==========================================================================\n   Dashboard.responsive.css\n   Responsive Stylesheet for MedGen Intelligence Dashboard\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgdash-page {\n    width: 100%;\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n\n  .mgdash-shell {\n    grid-template-columns: 1fr !important;\n    gap: 18px !important;\n    padding: 12px 16px 36px !important;\n    margin-top: 8px !important;\n  }\n\n  .mgdash-rail {\n    position: static !important;\n    display: grid !important;\n    grid-template-columns: 1fr !important;\n    gap: 14px !important;\n  }\n\n  /* Responsive Steps row on tablets */\n  .mgdash-steps-card {\n    padding: 14px 16px !important;\n  }\n\n  .mgdash-steps-card .mgdash-kicker {\n    margin-bottom: 8px !important;\n  }\n\n  /* Quick Actions horizontal on tablet */\n  .mgdash-action-card {\n    padding: 14px 16px !important;\n  }\n\n  .mgdash-action-card .mgdash-kicker {\n    margin-bottom: 8px !important;\n  }\n\n  .mgdash-action-card {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    align-items: center !important;\n    gap: 8px !important;\n  }\n\n  .mgdash-action-card .mgdash-kicker {\n    flex: 1 1 100% !important;\n  }\n\n  .mgdash-action-card .mgdash-btn {\n    flex: 1 1 calc(33.333% - 8px) !important;\n    min-width: 120px !important;\n    margin-top: 0 !important;\n  }\n\n  /* Hero Card */\n  .mgdash-hero-card {\n    grid-template-columns: 1fr !important;\n    gap: 22px !important;\n    padding: 24px !important;\n  }\n\n  .mgdash-cockpit {\n    max-width: 100% !important;\n    padding: 22px !important;\n  }\n\n  .mgdash-hero-copy h1 {\n    font-size: clamp(28px, 4.2vw, 38px) !important;\n    line-height: 1.08 !important;\n  }\n\n  .mgdash-patient-grid,\n  .mgdash-session-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 14px !important;\n  }\n\n  .mgdash-section-head {\n    grid-template-columns: 1fr !important;\n    gap: 14px !important;\n  }\n\n  .mgdash-filters,\n  .mgdash-filters.session {\n    grid-template-columns: minmax(0, 1.4fr) 180px auto !important;\n    gap: 10px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgdash-shell {\n    padding: 8px 10px 28px !important;\n    gap: 14px !important;\n  }\n\n  /* Steps card on mobile: compact 2x2 grid */\n  .mgdash-steps-card {\n    padding: 12px !important;\n  }\n\n  .mgdash-steps-card {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 8px !important;\n  }\n\n  .mgdash-steps-card .mgdash-kicker {\n    grid-column: 1 / -1 !important;\n    margin-bottom: 4px !important;\n  }\n\n  .mgdash-step {\n    min-height: 48px !important;\n    padding: 8px 10px !important;\n    margin-bottom: 0 !important;\n    grid-template-columns: 22px 1fr !important;\n    column-gap: 6px !important;\n  }\n\n  .mgdash-step b {\n    font-size: 11px !important;\n  }\n\n  .mgdash-step span {\n    font-size: 11px !important;\n    font-weight: 750 !important;\n    line-height: 1.2 !important;\n  }\n\n  .mgdash-step small {\n    display: none !important;\n  }\n\n  /* Action buttons stacked or 2-col on phone */\n  .mgdash-action-card .mgdash-btn {\n    flex: 1 1 calc(50% - 6px) !important;\n    min-width: 100px !important;\n    min-height: 40px !important;\n    font-size: 12px !important;\n  }\n\n  .mgdash-action-card .mgdash-btn:last-child {\n    flex: 1 1 100% !important;\n  }\n\n  /* Selected Card */\n  .mgdash-selected-card {\n    padding: 14px !important;\n  }\n\n  .mgdash-selected-card h3 {\n    font-size: 16px !important;\n  }\n\n  .mgdash-selected-card p {\n    font-size: 12px !important;\n    margin-bottom: 10px !important;\n  }\n\n  /* Hero Section */\n  .mgdash-hero-card {\n    padding: 16px 14px !important;\n    gap: 16px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgdash-hero-copy h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n    letter-spacing: -0.015em !important;\n  }\n\n  .mgdash-hero-copy p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 10px 0 14px !important;\n  }\n\n  .mgdash-hero-actions {\n    display: flex !important;\n    gap: 8px !important;\n    width: 100% !important;\n  }\n\n  .mgdash-hero-actions .mgdash-btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 12.5px !important;\n  }\n\n  /* Activity Bar Chart */\n  .mgdash-activity-card {\n    margin-top: 18px !important;\n    padding: 14px 12px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgdash-activity-head {\n    margin-bottom: 12px !important;\n  }\n\n  .mgdash-activity-head strong {\n    font-size: 15px !important;\n  }\n\n  .mgdash-bar-chart {\n    height: 125px !important;\n    gap: 8px !important;\n  }\n\n  .mgdash-bar-track {\n    max-width: 44px !important;\n  }\n\n  /* Cockpit */\n  .mgdash-cockpit {\n    padding: 16px 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgdash-cockpit-top h3 {\n    font-size: 16px !important;\n  }\n\n  .mgdash-cockpit p {\n    font-size: 12px !important;\n    line-height: 1.45 !important;\n  }\n\n  /* 3 Circle Stats */\n  .mgdash-circle-row {\n    display: grid !important;\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgdash-circle-stat {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    text-align: center !important;\n  }\n\n  .mgdash-circle {\n    width: 60px !important;\n    height: 60px !important;\n  }\n\n  .mgdash-circle span {\n    font-size: 14px !important;\n    font-weight: 850 !important;\n  }\n\n  .mgdash-circle-stat p {\n    font-size: 11px !important;\n    margin-top: 4px !important;\n  }\n\n  .mgdash-circle-stat small {\n    display: none !important;\n  }\n\n  .mgdash-cockpit-boxes {\n    gap: 8px !important;\n    margin-top: 14px !important;\n  }\n\n  .mgdash-cockpit-boxes div {\n    padding: 10px 12px !important;\n  }\n\n  .mgdash-cockpit-boxes strong {\n    font-size: 15px !important;\n  }\n\n  /* Grids to 1 column on phone */\n  .mgdash-patient-grid,\n  .mgdash-session-grid {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n\n  /* Filter toolbar */\n  .mgdash-filters,\n  .mgdash-filters.session {\n    grid-template-columns: 1fr !important;\n    gap: 8px !important;\n    width: 100% !important;\n  }\n\n  .mgdash-filters input,\n  .mgdash-filters select,\n  .mgdash-filters.session input,\n  .mgdash-filters.session select {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13.5px !important;\n  }\n\n  .mgdash-filters .mgdash-btn,\n  .mgdash-filters.session .mgdash-btn {\n    width: 100% !important;\n    min-height: 40px !important;\n  }\n\n  /* Patient Card */\n  .mgdash-patient-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgdash-patient-top {\n    display: flex !important;\n    align-items: center !important;\n    gap: 10px !important;\n  }\n\n  .mgdash-avatar {\n    width: 42px !important;\n    height: 42px !important;\n    font-size: 13px !important;\n    flex-shrink: 0 !important;\n  }\n\n  .mgdash-patient-meta h3 {\n    font-size: 15px !important;\n  }\n\n  .mgdash-count-chip {\n    margin-left: auto !important;\n    font-size: 10.5px !important;\n  }\n\n  .mgdash-patient-bottom {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    margin-top: 12px !important;\n    gap: 8px !important;\n  }\n\n  .mgdash-card-actions {\n    display: flex !important;\n    gap: 6px !important;\n  }\n\n  .mgdash-card-actions .mgdash-btn {\n    min-height: 34px !important;\n    padding: 6px 12px !important;\n    font-size: 11.5px !important;\n  }\n\n  /* Session Card */\n  .mgdash-session-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgdash-session-top {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 8px !important;\n  }\n\n  .mgdash-session-badges {\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    gap: 6px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
